import React from "react";

import dayjs from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
dayjs.extend(timezone);
dayjs.extend(utc);

const MAX_TIME_WINDOW_DURATIOM = 86400000; // 1 day

export const TimeWindowSelectorContext = React.createContext();

export const timeWindowSelectorDefaultState = {
  timezone: "KST",
  startTime: "",
  endTime: "",
};

export const timeWindowSelectorReducer = (state, action) => {
  switch (action.type) {
    case "SET_VALUE": {
      const { key, value: rawValue } = action;
      const value = rawValue && rawValue.trim ? rawValue.trim() : rawValue;
      if (value !== state[key]) {
        return { ...state, [key]: value };
      }
      return state;
    }
    default:
      return state;
  }
};

const DATETIME_API_QUERY_FORMAT = "YYYY-MM-DDTHH:mm:ss";
const DATETIME_API_QUERY_FORMAT_WITH_MS = "YYYY-MM-DDTHH:mm:ss.SSS";
export const getTimeWindowApiFilter = (state) => {
  const { timezone, startTime, endTime } = state;
  if (!startTime) {
    throw new Error("noStartTimeError");
  }
  if (!endTime) {
    throw new Error("noEndTimeError");
  }

  const timeZoneDbName = timezone === "KST" ? "Asia/Seoul" : "UTC";
  let startTimeObj = dayjs(startTime).tz(timeZoneDbName, true);
  let endTimeObj = dayjs(endTime).tz(timeZoneDbName, true);

  if (!startTimeObj.isValid()) {
    throw new Error("invalidStartTimeError");
  }

  if (
    startTimeObj.isBefore(dayjs.utc("2015-12-31")) ||
    startTimeObj.isAfter(dayjs.utc())
  ) {
    throw new Error("startTimeOutOfRangeError");
  }

  if (!endTimeObj.isValid()) {
    throw new Error("invalidEndTimeError");
  }

  if (
    endTimeObj.isBefore(dayjs.utc("2015-12-31")) ||
    endTimeObj.isAfter(dayjs.utc().add(1, "day"))
  ) {
    throw new Error("endTimeOutOfRangeError");
  }

  const duration = endTimeObj - startTimeObj;
  if (duration === 0) {
    throw new Error("startTimeAndEndTimeEqualError");
  } else if (duration < 0) {
    throw new Error("startTimeLaterThanEndTimeError");
  } else if (duration > MAX_TIME_WINDOW_DURATIOM) {
    throw new Error("maxDownloadDurationExceededError");
  }

  console.log(startTimeObj, endTimeObj);
  return {
    start: startTimeObj
      .utc()
      .format(
        startTimeObj.millisecond()
          ? DATETIME_API_QUERY_FORMAT_WITH_MS
          : DATETIME_API_QUERY_FORMAT
      ),
    end: endTimeObj
      .utc()
      .format(
        endTimeObj.millisecond()
          ? DATETIME_API_QUERY_FORMAT_WITH_MS
          : DATETIME_API_QUERY_FORMAT
      ),
  };
};
